import { constants, typographyStyles } from "@newsela/angelou";

const { heading6Obj } = typographyStyles;
const { colors } = constants;

export const copyrightCss = {
  ...heading6Obj,
  color: colors.ui.neutral[400],
  margin: "40px 0",
};
